// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiMintingClaimsPhaseTotalItem {
    /**
    * Phase name
    */
    'phase': string;
    /**
    * Number of unique addresses in this phase
    */
    'addresses': number;
    /**
    * Sum of spots for this phase
    */
    'total': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "phase",
            "baseName": "phase",
            "type": "string",
            "format": ""
        },
        {
            "name": "addresses",
            "baseName": "addresses",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "total",
            "baseName": "total",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiMintingClaimsPhaseTotalItem.attributeTypeMap;
    }

    public constructor() {
    }
}

